import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Customers.module.scss";
import useDeviceDetection from "../../../hooks/useDeviceDetection";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL_BACKEND_FOR_MEDIA } from "../../../const/api";
import {
  selectLogotypes,
  selectLogotypesMedia,
  selectPartners,
  selectPartnersMedia,
} from "../../../store/selectors/content/logotypesAndPartnersSelectors";
import {
  fetchLogotypes,
  fetchLogotypesMedia,
  fetchPartners,
  fetchPartnersMedia,
} from "../../../store/api/content/logotypesAndPartnersApi";

const Customers = () => {
  const { t } = useTranslation();
  const [hoveredLogo, setHoveredLogo] = useState(null);
  const device = useDeviceDetection();
  const dispatch = useDispatch();
  const isMobile = device === "Mobile";

  const currentLanguage = localStorage.getItem("language") === "heb" ? "he" : "en";

  const logotypesData = useSelector((state) => selectLogotypes(state, currentLanguage));
  const logotypesMediaData = useSelector((state) => selectLogotypesMedia(state));
  const partnersData = useSelector((state) => selectPartners(state, currentLanguage));
  const partnersMediaData = useSelector((state) => selectPartnersMedia(state));

  useEffect(() => {
    if (!logotypesData) dispatch(fetchLogotypes(currentLanguage));
    if (!logotypesMediaData) dispatch(fetchLogotypesMedia());
    if (!partnersData) dispatch(fetchPartners(currentLanguage));
    if (!partnersMediaData) dispatch(fetchPartnersMedia());
  }, [dispatch, currentLanguage, logotypesData, logotypesMediaData, partnersData, partnersMediaData]);

  const renderLogo = (logo, id) => {
    // На мобилке всегда берем logo.hover (цветной вариант)
    const src = isMobile 
      ? logo.hover 
      : (hoveredLogo === id ? logo.hover : logo.default);
    
    return (
      <div
        key={id}
        className={styles.logo}
        onMouseEnter={() => !isMobile && setHoveredLogo(id)}
        onMouseLeave={() => !isMobile && setHoveredLogo(null)}
      >
        <img
          src={`${BASE_URL_BACKEND_FOR_MEDIA}${src}`}
          alt="logo"
          loading="lazy"
        />
      </div>
    );
  };

  const cards = logotypesMediaData?.Cards || [];
  const partnerCards = partnersMediaData?.Cards || [];

  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <div className={`${styles.title} ${currentLanguage === "he" ? styles.hebFont : styles.enFont}`}>
          {logotypesData?.Title?.title?.split(/\/color\/(.*?)\/color\//g).map((part, index) => (
            index % 2 === 1 ? <span key={index} className={styles.orange}>{part}</span> : part
          ))}
        </div>
      </div>

      <div className={isMobile ? styles.mobileGrid : styles.desktopRows}>
        {!isMobile ? (
          <>
            {[0, 5, 10, 15].map((start) => (
              <div className={styles.logoRow} key={`row-${start}`}>
                {cards.slice(start, start + 5).map((logo, i) => renderLogo(logo, `d-${start}-${i}`))}
              </div>
            ))}
          </>
        ) : (
          /* На мобилке выводим всё одним списком, сетка CSS сама их расставит */
          <div className={styles.logoGrid}>
             {cards.map((logo, i) => renderLogo(logo, `m-${i}`))}
          </div>
        )}
      </div>

      <div className={`${styles.title} ${currentLanguage === 'he' ? styles.hebFont : styles.enFont} ${styles.partnerTitleMargin}`}>
        {partnersData?.Title?.title?.split(/\/color\/(.*?)\/color\//g).map((part, index) => (
          index % 2 === 1 ? <span key={index} className={styles.orange}>{part}</span> : part
        )) || t("partners")}
      </div>
      
      <div className={styles.logoContainerPartner}>
        {partnerCards.map((logo, i) => renderLogo(logo, `p-${i}`))}
      </div>
    </div>
  );
};

export default Customers;